import React from 'react'
import { t } from 'i18next'

import { ErrorPage } from '../ErrorPage'

export const MaintenanceMode = () => (
  <ErrorPage
    message={t('errors:other.pageOutOfOrder')}
    illustration="house-locked"
  />
)
